import { render, staticRenderFns } from "./comp_CheckoutStep-signin--active.vue?vue&type=template&id=3bfb9a8c&scoped=true&"
import script from "./comp_CheckoutStep-signin--active.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-signin--active.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-signin--active.vue?vue&type=style&index=0&id=3bfb9a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfb9a8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VDivider,VIcon})
